module.exports = __webpack_public_path__ + "img/bx_duplicate.c40fcfb3.svg";